import React, { useEffect, useState } from "react";
import style from "./Everypermission.module.css";
import {  collection, doc, getDoc, getDocs, updateDoc} from "firebase/firestore";
import { db } from "../../firebase/config";
import "react-toastify/dist/ReactToastify.css"
import {ToastContainer, toast} from"react-toastify"
import { Link } from "react-router-dom";
import { PiFilePdfBold } from "react-icons/pi";
const Everypermission=(props)=>{
    const [chat,setChat]=useState();
    const [chats,setChats]=useState([]);
    useEffect(()=>{
        const getchat=async()=>{
            const docRef = doc(db, "roomuser", props.message.chatid);
            const docSnap = await getDoc(docRef);
            setChat(docSnap.data())
        }
        getchat()
    },[props.message.chatid])
    useEffect(()=>{
        const getallmessages=async ()=>{
         const querySnapshot = await getDocs(collection(db, "messages"));
         const demo=[];
         querySnapshot.forEach((doc) => {
             doc.data()?.message?.forEach((everymessage)=>{
                    demo.push(everymessage)
             })
         });
         setChats(demo);
        }
        getallmessages()
    },[])
    return(
        <tr>
            <ToastContainer/>
            <td >
                <svg  onClick={props.approved.bind(this,props.message.id)} xmlns="http://www.w3.org/2000/svg" width="51" height="36" viewBox="0 0 51 36" fill="none">
                    <path d="M48 3L17.0625 33L3 19.3636" stroke="#6C9E39" stroke-width="4.42105" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                او
                <svg onClick={props.reject.bind(this,props.message.id)} xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                    <path d="M31.8787 1.86353C33.0503 3.0351 33.0503 4.9346 31.8787 6.10617L23.6062 14.3787C22.4346 15.5503 22.4346 17.4497 23.6062 18.6213L31.8787 26.8938C33.0503 28.0654 33.0503 29.9649 31.8787 31.1365L31.1335 31.8817C29.9631 33.0521 28.0659 33.0534 26.8938 31.8847L18.6213 23.6355C17.4493 22.4668 15.5521 22.4681 14.3817 23.6385L6.14152 31.8787C4.96995 33.0503 3.07045 33.0503 1.89888 31.8787L1.12132 31.1011C-0.0502537 29.9295 -0.0502528 28.0301 1.12132 26.8585L9.35848 18.6213C10.5301 17.4497 10.5301 15.5503 9.35848 14.3787L1.12132 6.14152C-0.0502539 4.96995 -0.0502523 3.07045 1.12132 1.89888L1.89888 1.12132C3.07045 -0.050254 4.96995 -0.0502526 6.14152 1.12132L14.3817 9.36148C15.5521 10.5319 17.4493 10.5332 18.6213 9.36447L26.8938 1.11532C28.0659 -0.0534213 29.9631 -0.0520792 31.1335 1.11832L31.8787 1.86353Z" fill="#DB1313"/>
                </svg>
            </td>
            <td>
                {props.message.type === "image" ? <Link target="_blank" to={props.message.file} ><img src={props.message.file} alt="picture message"/></Link> : null   }
                {props.message.type === "video" ? <Link target="_blank" to={props.message.file} ><video width="300px" height="200px" controls ><source src={props.message.file} type="video/mp4"/></video></Link>: null   }
                {props.message.type === "file" ? <Link target="_blank" to={props.message.file} ><PiFilePdfBold color="black" size={60}/></Link>: null   }
            </td>
            <td>
                <div className={style.infocard}>
                    {chat&& <img src={chat.imageurl}/>}
                    <div>
                        {chat&& <p>{chat.name}</p>}
                        {chat&& <p>الراسل : {props.message.sendername}</p>}
                    </div>
                </div>
            </td>
        </tr>
    )
}
export default Everypermission